module.exports = __webpack_public_path__ + "img/menu2.84454e47.svg";